import { Link, Outlet } from "react-router-dom"
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar"
import { AdminSidebar } from "./AdminSidebar"

export function AdminLayout() {
  return (
    <SidebarProvider>
      <div className="flex h-dvh w-full">
        <AdminSidebar />
        <main className="flex-1 overflow-auto">
          {/* モバイル: 768px 未満ではサイドバーが初期閉のシートになるため、開閉ボタンが
              ないとメニュー切替も Chat への復帰もできなくなる（画面上の導線ゼロ）。
              デスクトップはサイドバー常時表示なのでこのバーは出さない */}
          <div className="flex items-center gap-2 p-2 border-b md:hidden">
            <SidebarTrigger className="shrink-0" />
            <span className="text-sm font-semibold">管理</span>
            <Link to="/" className="ml-auto text-sm text-muted-foreground underline">
              ← チャットへ
            </Link>
          </div>
          <div className="p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </SidebarProvider>
  )
}
